export enum Languages {
  'en-us' = 'en-us',
  'fr-fr' = 'fr-fr',
  'hu-hu' = 'hu-hu',
  'pl-pl' = 'pl-pl',
  'es-es' = 'es-es',
  'it-it' = 'it-it',
  'pt-pt' = 'pt-pt',
}
